export default class OrganizationDashboard {
    constructor (dto) {
        this.id = -1
        this.logo = ''
        this.name = ''
        this.totalDocuments = 0
        this.totalSignedDocuments = 0
        this.totalContentTypes = 0
        this.totalUsedSpace = 0
        this.totalUsedSpaceDisplay = ''
        this.maxUsedSpace = 0
        this.maxUsedSpaceDisplay = ''
        this.totalUsers = 0
        this.totalFullUsers = 0
        this.maxFullUsers = 0
        this.totalReadonlyUsers = 0
        this.maxReadonlyUsers = 0
        this.totalConcurrentUsers = 0
        this.maxConcurrentUsers = 0
        this.total2FAUsers = 0
        this.max2FAUsers = 0
        this.totalDevices = 0
        this.maxDevices = 0
        this.adminUser = null

        if (dto) {
            this.id = dto.Id
            this.logo = dto.Logo
            this.name = dto.Name
            this.totalDocuments = dto.TotalDocuments
            this.totalSignedDocuments = dto.TotalSignedDocuments
            this.totalContentTypes = dto.TotalContentTypes
            this.totalUsedSpace = dto.TotalUsedSpace
            this.totalUsedSpaceDisplay = dto.TotalUsedSpaceDisplay
            this.maxUsedSpace = dto.MaxUsedSpace
            this.maxUsedSpaceDisplay = dto.MaxUsedSpaceDisplay
            this.totalUsers = dto.TotalUsers
            this.totalFullUsers = dto.TotalFullUsers
            this.maxFullUsers = dto.MaxFullUsers
            this.totalReadonlyUsers = dto.TotalReadonlyUsers
            this.maxReadonlyUsers = dto.MaxReadonlyUsers
            this.totalConcurrentUsers = dto.TotalConcurrentUsers
            this.maxConcurrentUsers = dto.MaxConcurrentUsers
            this.total2FAUsers = dto.Total2FAUsers
            this.max2FAUsers = dto.Max2FAUsers
            this.totalDevices = dto.TotalDevices
            this.maxDevices = dto.MaxDevices
            this.adminUser = dto.AdminUser
        }
    }

    toDto () {
        return {
            Name: this.name,
            Logo: this.logo,
        }
    }
}
